export default __webpack_public_path__ + "static/media/funda.a9edc94a.svg";